export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      trips: "Sorties Pêche",
      gallery: "Galerie",
      contact: "Contact",
      book: "Réserver",
      admin: "Admin"
    },
    // Hero
    hero: {
      title: "Sortie Pêche",
      titleLine2: "en Corse",
      subtitle: "Embarquez pour une aventure unique sur les eaux turquoise de la Corse",
      cta: "Découvrir nos sorties"
    },
    // Trips
    trips: {
      title: "Nos Sorties Pêche",
      duration: "Durée",
      hours: "heures",
      price: "À partir de",
      perPerson: "/ participant",
      privatization: "Privatisation",
      maxParticipants: "Max 4 participants",
      book: "Réserver",
      details: "En savoir plus",
      availableSlots: "Créneaux disponibles",
      spotsAvailable: "places disponibles",
      fullyBooked: "Complet",
      important: "Important : La pêche n'est pas une science exacte ! Il arrive parfois qu'on rentre sans prise, mais l'essentiel reste l'expérience en mer et le plaisir du moment."
    },
    // Booking
    booking: {
      title: "Réservation",
      selectDate: "Sélectionnez une date",
      selectSlot: "Choisissez un créneau",
      participants: "Participants",
      addParticipant: "Ajouter un participant",
      removeParticipant: "Retirer",
      firstName: "Prénom",
      lastName: "Nom",
      age: "Âge",
      phone: "Téléphone",
      email: "Email",
      privatize: "Privatiser le bateau",
      privatizeDesc: "Réservez le bateau entier pour votre groupe",
      total: "Total",
      pay: "Payer",
      processing: "Traitement en cours...",
      success: "Réservation confirmée !",
      error: "Erreur lors de la réservation",
      confirmationSent: "Un email de confirmation vous a été envoyé"
    },
    // Gallery
    gallery: {
      title: "Notre Galerie",
      subtitle: "Découvrez nos plus belles prises et moments en mer"
    },
    // Contact
    contact: {
      title: "Nous Contacter",
      address: "Port de Plaisance, Calvi, Corse",
      phone: "Téléphone",
      email: "Email",
      followUs: "Suivez-nous"
    },
    // Boat
    boat: {
      title: "Le Bateau",
      name: "ANDILANA",
      description: "De construction récente, le bateau de CALVI FISHING a été baptisé ANDILANA. Paul Salvi, votre guide et moniteur de pêche. Ce Bayliner Trophy 2503 CC, conçu pour la pêche sportive, allie performance et confort.",
      specs: "Avec son moteur Mercury 350 CV, il offre une navigation rapide et stable, même par mer agitée."
    },
    // Features
    features: {
      guide: "1 guide expérimenté et passionné",
      boat: "1 bateau bien équipé et sécurisé",
      region: "1 région de rêve en Balagne",
      privatization: "Possibilité de privatisation",
      children: "Enfants acceptés accompagnés d'un adulte",
      authentic: "Un maximum d'authenticité"
    },
    // Footer
    footer: {
      rights: "Tous droits réservés",
      legal: "Mentions légales",
      privacy: "Politique de confidentialité"
    },
    // Common
    common: {
      loading: "Chargement...",
      error: "Une erreur est survenue",
      close: "Fermer",
      cancel: "Annuler",
      confirm: "Confirmer",
      save: "Enregistrer",
      delete: "Supprimer",
      edit: "Modifier",
      back: "Retour",
      next: "Suivant",
      previous: "Précédent"
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      trips: "Fishing Trips",
      gallery: "Gallery",
      contact: "Contact",
      book: "Book Now",
      admin: "Admin"
    },
    // Hero
    hero: {
      title: "Sea Fishing",
      titleLine2: "in Corsica",
      subtitle: "Embark on a unique adventure on the turquoise waters of Corsica",
      cta: "Discover our trips"
    },
    // Trips
    trips: {
      title: "Our Fishing Trips",
      duration: "Duration",
      hours: "hours",
      price: "From",
      perPerson: "/ person",
      privatization: "Privatization",
      maxParticipants: "Max 4 participants",
      book: "Book Now",
      details: "Learn more",
      availableSlots: "Available slots",
      spotsAvailable: "spots available",
      fullyBooked: "Fully booked",
      important: "Important: Fishing is not an exact science! Sometimes we come back empty-handed, but the essential is the experience at sea and the joy of the moment."
    },
    // Booking
    booking: {
      title: "Booking",
      selectDate: "Select a date",
      selectSlot: "Choose a time slot",
      participants: "Participants",
      addParticipant: "Add participant",
      removeParticipant: "Remove",
      firstName: "First Name",
      lastName: "Last Name",
      age: "Age",
      phone: "Phone",
      email: "Email",
      privatize: "Privatize the boat",
      privatizeDesc: "Book the entire boat for your group",
      total: "Total",
      pay: "Pay",
      processing: "Processing...",
      success: "Booking confirmed!",
      error: "Booking error",
      confirmationSent: "A confirmation email has been sent to you"
    },
    // Gallery
    gallery: {
      title: "Our Gallery",
      subtitle: "Discover our best catches and moments at sea"
    },
    // Contact
    contact: {
      title: "Contact Us",
      address: "Marina, Calvi, Corsica",
      phone: "Phone",
      email: "Email",
      followUs: "Follow us"
    },
    // Boat
    boat: {
      title: "The Boat",
      name: "ANDILANA",
      description: "Recently built, the CALVI FISHING boat was named ANDILANA. Paul Salvi, your fishing guide and instructor. This Bayliner Trophy 2503 CC, designed for sport fishing, combines performance and comfort.",
      specs: "With its 350 HP Mercury engine, it offers fast and stable navigation, even in rough seas."
    },
    // Features
    features: {
      guide: "1 experienced and passionate guide",
      boat: "1 well-equipped and safe boat",
      region: "1 dream region in Balagne",
      privatization: "Privatization option",
      children: "Children accepted with adult",
      authentic: "Maximum authenticity"
    },
    // Footer
    footer: {
      rights: "All rights reserved",
      legal: "Legal notice",
      privacy: "Privacy policy"
    },
    // Common
    common: {
      loading: "Loading...",
      error: "An error occurred",
      close: "Close",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      delete: "Delete",
      edit: "Edit",
      back: "Back",
      next: "Next",
      previous: "Previous"
    }
  },
  it: {
    // Navigation
    nav: {
      home: "Home",
      trips: "Uscite di Pesca",
      gallery: "Galleria",
      contact: "Contatti",
      book: "Prenota",
      admin: "Admin"
    },
    // Hero
    hero: {
      title: "Pesca in Mare",
      titleLine2: "in Corsica",
      subtitle: "Imbarcati per un'avventura unica sulle acque turchesi della Corsica",
      cta: "Scopri le nostre uscite"
    },
    // Trips
    trips: {
      title: "Le Nostre Uscite di Pesca",
      duration: "Durata",
      hours: "ore",
      price: "Da",
      perPerson: "/ persona",
      privatization: "Privatizzazione",
      maxParticipants: "Max 4 partecipanti",
      book: "Prenota ora",
      details: "Scopri di più",
      availableSlots: "Orari disponibili",
      spotsAvailable: "posti disponibili",
      fullyBooked: "Completo",
      important: "Importante: La pesca non è una scienza esatta! A volte si torna senza prede, ma l'essenziale resta l'esperienza in mare e il piacere del momento."
    },
    // Booking
    booking: {
      title: "Prenotazione",
      selectDate: "Seleziona una data",
      selectSlot: "Scegli un orario",
      participants: "Partecipanti",
      addParticipant: "Aggiungi partecipante",
      removeParticipant: "Rimuovi",
      firstName: "Nome",
      lastName: "Cognome",
      age: "Età",
      phone: "Telefono",
      email: "Email",
      privatize: "Privatizza la barca",
      privatizeDesc: "Prenota l'intera barca per il tuo gruppo",
      total: "Totale",
      pay: "Paga",
      processing: "Elaborazione...",
      success: "Prenotazione confermata!",
      error: "Errore di prenotazione",
      confirmationSent: "Ti è stata inviata un'email di conferma"
    },
    // Gallery
    gallery: {
      title: "La Nostra Galleria",
      subtitle: "Scopri le nostre migliori catture e momenti in mare"
    },
    // Contact
    contact: {
      title: "Contattaci",
      address: "Porto turistico, Calvi, Corsica",
      phone: "Telefono",
      email: "Email",
      followUs: "Seguici"
    },
    // Boat
    boat: {
      title: "La Barca",
      name: "ANDILANA",
      description: "Di recente costruzione, la barca di CALVI FISHING è stata battezzata ANDILANA. Paul Salvi, la tua guida e istruttore di pesca. Questo Bayliner Trophy 2503 CC, progettato per la pesca sportiva, unisce prestazioni e comfort.",
      specs: "Con il suo motore Mercury da 350 CV, offre una navigazione veloce e stabile, anche con mare agitato."
    },
    // Features
    features: {
      guide: "1 guida esperta e appassionata",
      boat: "1 barca ben equipaggiata e sicura",
      region: "1 regione da sogno in Balagne",
      privatization: "Possibilità di privatizzazione",
      children: "Bambini accettati con adulto",
      authentic: "Massima autenticità"
    },
    // Footer
    footer: {
      rights: "Tutti i diritti riservati",
      legal: "Note legali",
      privacy: "Privacy policy"
    },
    // Common
    common: {
      loading: "Caricamento...",
      error: "Si è verificato un errore",
      close: "Chiudi",
      cancel: "Annulla",
      confirm: "Conferma",
      save: "Salva",
      delete: "Elimina",
      edit: "Modifica",
      back: "Indietro",
      next: "Avanti",
      previous: "Precedente"
    }
  }
};
